"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerPresentationControl = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PDF = require("../PDF");
var _reactPdf = require("react-pdf");
var _PresentationControlPageInput = require("../PresentationControlPageInput");
require("react-pdf/dist/Page/AnnotationLayer.css");
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _SpeakerPresentationControl = require("./SpeakerPresentationControl.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _hooks = require("../../hooks");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _Reusable = require("../../constants/Reusable");
var _pdf = require("../../utils/pdf");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var logger = new _StudioLogger.StudioLogger('presentation-control');
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (0, _pdf.pdfWorkerFactory)();
var DEFAULT_WIDTH = 268;
var SpeakerPresentationControl = exports.SpeakerPresentationControl = function SpeakerPresentationControl(_ref) {
  var url = _ref.url,
    id = _ref.id,
    title = _ref.title,
    presentationValue = _ref.presentationValue,
    onSourceChanged = _ref.onSourceChanged,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? DEFAULT_WIDTH : _ref$width,
    _ref$showNextLabel = _ref.showNextLabel,
    showNextLabel = _ref$showNextLabel === void 0 ? true : _ref$showNextLabel,
    _ref$isResponsiveVers = _ref.isResponsiveVersion,
    isResponsiveVersion = _ref$isResponsiveVers === void 0 ? false : _ref$isResponsiveVers,
    _ref$isDarkTheme = _ref.isDarkTheme,
    isDarkTheme = _ref$isDarkTheme === void 0 ? false : _ref$isDarkTheme,
    _ref$isExpandedView = _ref.isExpandedView,
    isExpandedView = _ref$isExpandedView === void 0 ? false : _ref$isExpandedView,
    presentationControlPopOverClicked = _ref.presentationControlPopOverClicked;
  var tooltipPlacement = isResponsiveVersion ? 'top' : 'bottom';
  var verticalPadding = 40;
  var containerWidth = +width === 0 ? 268 : width;
  var presentationMaxWidth = containerWidth - verticalPadding;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    popoverOpen = _useState2[0],
    setPopoverOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    renderedPage = _useState4[0],
    setRenderedPage = _useState4[1];
  (0, _react.useEffect)(function () {
    setPopoverOpen(!presentationControlPopOverClicked.current);
  }, []);
  var _usePresentationContr = (0, _hooks.usePresentationControl)({
      id: id,
      title: title,
      presentationValue: presentationValue,
      onSourceChanged: onSourceChanged
    }),
    numPages = _usePresentationContr.numPages,
    showNextPageNumber = _usePresentationContr.showNextPageNumber,
    setShowNextPageNumber = _usePresentationContr.setShowNextPageNumber,
    presentationDimension = _usePresentationContr.presentationDimension,
    activePage = _usePresentationContr.activePage,
    onDocumentLoadSuccess = _usePresentationContr.onDocumentLoadSuccess,
    goToNextPage = _usePresentationContr.goToNextPage,
    goToPreviousPage = _usePresentationContr.goToPreviousPage,
    leftThumbnailPage = _usePresentationContr.leftThumbnailPage,
    rightThumbnailPage = _usePresentationContr.rightThumbnailPage,
    isDocumentLoaded = _usePresentationContr.isDocumentLoaded,
    pageNumberInputHasError = _usePresentationContr.pageNumberInputHasError,
    handlePageInputChange = _usePresentationContr.handlePageInputChange,
    inputPageNumber = _usePresentationContr.inputPageNumber,
    handlePageInputKeyPress = _usePresentationContr.handlePageInputKeyPress,
    showInputForm = _usePresentationContr.showInputForm,
    presentationFooterRef = _usePresentationContr.presentationFooterRef;
  (0, _react.useEffect)(function () {
    if (activePage === numPages) {
      setRenderedPage(rightThumbnailPage);
    }
  }, [activePage]);
  if (!url) return null;
  var handleGotIt = function handleGotIt() {
    setPopoverOpen(false);
    presentationControlPopOverClicked.current = true;
    logger.info('Presentation Control - Speaker - Close Got It Popover', {
      presentation: {
        id: id,
        title: title
      }
    });
  };
  var handleRender = function handleRender() {
    setRenderedPage(rightThumbnailPage);
  };

  // A difference less than 0 means the next page is being rendered
  // A difference greater than 0 means the previous page is being rendered
  var difference = renderedPage - rightThumbnailPage;
  var isThumbnailLoading = rightThumbnailPage !== renderedPage && numPages > activePage;
  var disableNextButton = activePage === numPages || popoverOpen || isThumbnailLoading;
  var disablePreviousButton = leftThumbnailPage === 0 || isThumbnailLoading;
  return /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.SpeakerPresentationControlWrapper, {
    isResponsiveVersion: isResponsiveVersion,
    isExpandedView: isExpandedView,
    "data-testid": "speaker-presentation-control",
    isDarkTheme: isDarkTheme
  }, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledPresentationControllerWrapper, {
    isResponsiveVersion: isResponsiveVersion,
    "data-testid": "speaker-presentation-controller"
  }, !isResponsiveVersion && /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.PresentationTitle, {
    "data-testid": "presentation-title",
    className: "fw-bold",
    isDarkTheme: isDarkTheme
  }, title), /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.CurrentTotalPage, {
    "data-testid": "current-page",
    isResponsiveVersion: isResponsiveVersion,
    show: isDocumentLoaded,
    ref: presentationFooterRef
  }, /*#__PURE__*/_react["default"].createElement(_PresentationControlPageInput.PresentationControlPageInput, {
    hasError: pageNumberInputHasError,
    inputValue: inputPageNumber,
    onChange: handlePageInputChange,
    onKeyPress: handlePageInputKeyPress,
    numPages: numPages,
    showInputForm: showInputForm,
    isSpeaker: true
  })), /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledPresentationControllers, null, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledPreviousButton, {
    disabled: disablePreviousButton,
    onClick: goToPreviousPage,
    "data-testid": "speaker-control-panel-prev-btn",
    color: "light",
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(PreviousLabel, {
    isLoading: difference > 0
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledNextButton, {
    color: "primary",
    size: "small",
    id: "Popover",
    disabled: disableNextButton,
    onClick: goToNextPage,
    "data-testid": "speaker-control-panel-next-btn"
  }, /*#__PURE__*/_react["default"].createElement(NextLabel, {
    isLoading: difference < 0 && isThumbnailLoading,
    showNextLabel: showNextLabel
  })), !presentationControlPopOverClicked.current && /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledPopOver, {
    placement: tooltipPlacement,
    isOpen: popoverOpen,
    target: "Popover"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, null, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledGotItContainer, null, "You\u2019re presenting slides. Everyone with permission can advance the slides."), /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledGotItButton, {
    color: "outline",
    size: "small",
    onClick: handleGotIt,
    onKeyDown: function onKeyDown(e) {
      return (0, _Reusable.handleEnterDown)(e, handleGotIt);
    },
    "data-testid": "got-it-button",
    tabIndex: "0"
  }, "Got it"))))))), /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.DocumentWrapper, {
    presentationWidth: presentationMaxWidth,
    show: !isResponsiveVersion,
    "data-testid": "speaker-control-panel-presentation-thumbnail",
    onMouseEnter: function onMouseEnter() {
      return setShowNextPageNumber(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowNextPageNumber(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.HoverPageNumber, {
    showPageNumber: showNextPageNumber.toString(),
    visibility: !disableNextButton
  }, "Next: slide ".concat(rightThumbnailPage)), /*#__PURE__*/_react["default"].createElement(_PDF.StudioPDFDocument, {
    key: url,
    file: url,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.LoadingPage, {
      presentationWidth: presentationMaxWidth
    }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, null))
  }, rightThumbnailPage <= numPages && /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.StyledThumbnail, {
    pageNumber: rightThumbnailPage,
    maxWidth: presentationMaxWidth,
    maxHeight: 150,
    presentationDimension: presentationDimension,
    onRenderSuccess: handleRender,
    error: /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.EmptyPresentationScreen, {
      presentationWidth: presentationMaxWidth
    }),
    loading: /*#__PURE__*/_react["default"].createElement(_SpeakerPresentationControl.LoadingPage, {
      presentationWidth: presentationMaxWidth
    }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, null))
  }))));
};
var NextLabel = function NextLabel(_ref2) {
  var isLoading = _ref2.isLoading,
    showNextLabel = _ref2.showNextLabel;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
      "data-testid": "spinner-next",
      size: "sm"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(showNextLabel ? 'Next ' : ''), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowRight
  }));
};
var PreviousLabel = function PreviousLabel(_ref3) {
  var isLoading = _ref3.isLoading;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
      "data-testid": "spinner-previous",
      size: "sm"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowLeft
  });
};
SpeakerPresentationControl.propTypes = {
  url: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  presentationValue: _propTypes["default"].object.isRequired,
  onSourceChanged: _propTypes["default"].func.isRequired,
  width: _propTypes["default"].number,
  showNextLabel: _propTypes["default"].bool,
  isResponsiveVersion: _propTypes["default"].bool,
  isDarkTheme: _propTypes["default"].bool,
  isExpandedView: _propTypes["default"].bool,
  presentationControlPopOverClicked: _propTypes["default"].object.isRequired
};